import GenericErrorCodes from "../../../errorCodes/Generic";
var handlers = [genericErrorHandler];
var ErrorHandlerRegister = /** @class */ (function () {
    function ErrorHandlerRegister() {
    }
    ErrorHandlerRegister.prototype.add = function (handler) {
        // make sure we don't add the same handler more than once
        if (!handlers.includes(handler) && typeof handler === "function") {
            handlers.push(handler);
        }
    };
    ErrorHandlerRegister.prototype.remove = function () {
        throw new Error("[ErrorHandlerRegister]: Not yet implemented.");
    };
    ErrorHandlerRegister.prototype.getMessage = function (errorCode, error) {
        var message = "errors.unknownError";
        handlers.forEach(function (handler) {
            var msg = handler(errorCode, error);
            if (msg) {
                message = msg;
            }
        });
        return message;
    };
    return ErrorHandlerRegister;
}());
export default new ErrorHandlerRegister();
function genericErrorHandler(errCode) {
    switch (errCode) {
        case GenericErrorCodes.PBERRForbiddenNoPermission:
        case GenericErrorCodes.PBERRForbiddenRestrictionCheckFailed:
            return "errors.PBERRForbiddenNoPermission";
        case GenericErrorCodes.PBERRForbiddenInvalidToken:
        case GenericErrorCodes.PBERRTokenMissing:
            return "errors.PBERRForbiddenInvalidToken";
        default:
            return "";
    }
}
